import React from "react";
import { Grid } from "@mui/material";
import Charts from "./components/Charts";
import LeaseEvents from "../LeaseEvent/List";
import { useSelector } from "react-redux";

const TmeHome = ({ isloading }) => {
  const homePageData = useSelector((state) => state.pages.homePageData);
  const { preTransactionCounts, transactionCounts } = homePageData;
  const selectedClientId = useSelector(state => state.clients.selectedClientId);

  return (
    <>
      <Grid container sx={{ marginTop: "16px" }}>
        <Charts
          preTransactionCounts={preTransactionCounts}
          transactionCounts={transactionCounts}
          isLoading={isloading}
        />
      </Grid>
      <Grid container sx={{ marginTop: "40px" }}>
        <Grid item xs={12}>
          <LeaseEvents
            selectedClientId={selectedClientId}
            parent="homePage"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TmeHome;
